// extracted by mini-css-extract-plugin
export var loading = "Loading-module--loading--3fLx2";
export var loading1 = "Loading-module--loading1--iYo6g";
export var loading2 = "Loading-module--loading2--2fwqw";
export var loading3 = "Loading-module--loading3--14SDd";